export default {
  Nameofcontactperson: 'Name of contact person',
  return: 'return',
  submit: 'submit',
  female: 'female',
  male: 'male',
  IDnumber: 'ID number',
  sex: 'sex',
  phoneNumber: 'EXCEL',
  excelTip: 'Data can be imported through Excel',
  applyPass: 'apply pass of construction',
  add: 'add',
  listPass: 'list of apply pass',
  workerNumber: 'Number of construction workers',
  viewDetails: 'View details',
  ExhibitionName: 'Exhibition Name',
  detail: 'Details of Construction Personnel Pass Application',
  revise: 'Revise',
  hold: 'hold',
  Return: 'Return',
  companyName: 'company name',
  number: 'Number',
  ensureNumberTips: 'Be sure ensure the number of Construction personnel',
  information: 'information of Construction personnel',
  tip_1: 'This page is unable to modify the construction application, if you need to click',
  tip_2: 'Apply pass of construction',
  tip_3: 'Modification',
  '提示': 'tips',
  '是否确认提交': 'Confirmation of submission',
  '操作成功': 'Successful operation',
  '请输入联系人姓名': 'Please enter the name of the contact person',
  '请输入电话号码': 'Please enter your telephone number',
  '请输入身份证号': 'Please enter your ID number',
  '如有特殊情况请说明': 'If there is any special case, please explain.',
  '请输入正确的联系方式': 'Please enter the correct contact information',
  '请输入正确的身份证号': 'Please enter the correct ID number',
  '上一步': 'last step',
  '下一步': 'next',
  '男': 'male',
  '女': 'female',
  '新增人员': 'Additional applications',
  '每次最多只能导入50条施工证人员信息': 'Only a maximum of 50 construction permit personnel information can be imported at a time',
  '承建商': 'building business',

  "施工证申请": "Construction permit application",
  "申请须知": "Application Instructions",
  "已知悉": "Known",
  "新增申请": "New application",
  "暂无数据": "No data",
  "申请编号": "Application number",
  "承建商公司": "Contractor company",
  "施工展位": "Construction booth",
  "证件数量": "Number of documents",
  "状态": "status",
  "查看申请": "View application",
  "继续填写": "Continue to fill in",
  "修改资料": "Modify information",
  "取消申请": "cancel application",
  "资料填写": "Fill in the information",
  "搭建公司名称": "Construction company name",
  "请输入承建商公司名称": "Please enter the name of the builder company",
  "请输入承建商公司名称（可检索）": "Please enter the name of the contractor company (retrievable)",
  "添加展位": "Add booth",
  "人员信息": "Personnel information",
  "批量导入": "Batch Import",
  "可通过": "Adopt",
  "填写施工人员信息，批量导入人员信息": "Fill in the construction personnel information，Batch import personnel information",
  "可通过Excel批量导入人员信息": "Can import personnel information in batches through Excel",
  "点击下载导入表格模板": "click download to import the form template",
  "请勿导入超过30条数据，若人员较多，可另外新增申请": "Please do not import more than 30 data, if there are more people, you can add another application",
  "姓名": "Name",
  "性别": "Gender",
  "序号": "Serial number",
  "身份证号码": "Identification number",
  "联系电话": "contact number",
  "图片": "image",
  "操作": "operating",
  "审核意见": "Audit opinion",
  "添加人员": "Add people",
  "保存并提交": "Save and submit",
  "保存草稿": "save draft",
  "返回": "Back",
  "上传图片": "upload",
  "删除": "delete",
  "确定": "determine",
  "取消": "cancel",
  "请输入展位号": "Please enter the booth number",
  "请输入姓名": "Please type in your name",
  "请输入身份证号码": "Please enter the ID number",
  "请输入正确的身份证号码": "Please enter a valid ID number",
  "请输入电话": "Please enter the phone",
  "请输入正确的联系电话": "Please enter the correct contact number",
  "是否删除该项": "Whether to delete the item",
  "无此展位": "No such booth",
  "请上传": "Please upload ",
  "张": " photos",
  "图片数量不足": "There are unposted pictures",
  "您的施工证申请审核未通过": "Your construction permit application review failed",
  "必填项未填写，请检查": "Required fields are not filled in, please check",
  "姓名必填": "name is required",
  "身份证格式有误": "the ID format is wrong",
  "身份证信息必填": "ID card information is required",
  "手机号码格式有误": "the phone number format is wrong",
  "手机号码必填": "mobile phone number is required",
  "第": "Line ",
  "行": " ",
}



// WEBPACK FOOTER //
// ./src/i18n/en-us/constructionPermit.js